module.exports = __webpack_public_path__ + "img/get-coupon-btn-bf.3bd6af36.png";